





































import Vue from 'vue';
import { isNumber } from 'lodash';
import { BButton, BFormInput } from 'bootstrap-vue';

export default Vue.extend({
  name: 'Navigation',
  components: {
    BButton,
    BFormInput,
  },
  props: {
    allQuestionsValid: {
      type: Boolean,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    pageCount: {
      type: Number,
      required: true,
    },
    position: {
      type: String,
      required: true,
      validator(value) {
        return ['top', 'bottom'].indexOf(value) > -1;
      },
    },
    preview: {
      type: Boolean,
      default: () => false,
    },
    uploading: {
      type: Boolean,
      required: true,
    },
    savedAt: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return { valid: null };
  },
  computed: {
    nextDisabled() {
      const onSummary = this.currentPage === this.pageCount;
      return this.uploading || (onSummary && (this.preview || !this.allQuestionsValid || this.loading));
    },
    nextText() {
      if (this.currentPage === this.pageCount) {
        return 'Submit';
      } else if (this.currentPage === this.pageCount - 1) {
        return 'Summary';
      }
      return 'Next';
    },
    controlsBlockClass() {
      return ['controls-block', this.position];
    },
  },
  watch: {
    currentPage() {
      this.valid = null;
    },
  },
  methods: {
    move(offset: number) {
      this.$emit('goToPage', this.currentPage + offset);
    },
    save() {
      this.$emit('save', false, true, true);
    },
    goToPage(event) {
      const newPage = Number(event.currentTarget.value) - 1;
      if (isNumber(newPage) && newPage >= 0 && newPage < this.pageCount) {
        this.$emit('goToPage', newPage);
      } else {
        this.valid = false;
      }
    },
  },
});
